<template>
	<!-- 监理周报 -->
	<div class="mod-config">
		<el-col :span="24" style="margin-top:-10px">
			<el-card body-style="padding-bottom: 0;" style="margin-top: 5px;">
				<el-row class="title_color">
					<el-col :span="20">
						<div class="title">监理周报</div>
					</el-col>
					<el-col :span="4" style="margin-top:10px;margin-bottom:-10px">
						<i class="el-icon-sort" id="PointerIcon" style="right:1rem;transform:rotate(90deg);" @click="goBack()"></i>
						<el-button v-preventReClick type="text" @click="goBack()" class="backbtn">返回门户</el-button>
					</el-col>
				</el-row>
			</el-card>
			<div>
				<el-card style="margin-top: -3px;" body-style="padding: 0;">
					<el-row style="margin-bottom: 10px;">
						<el-col :span="24">
							<div class="box">
								<el-table :height="screenHeight - 110 + 'px'" :row-class-name="tableRowClassName" class="dataListTable" border
									:data="dataList" header-align="center" style="width: 100%; margin-bottom: 20px;"
									header-cell-class-name="dataListTHeader" :cell-style="{ padding: '0px' }">
									<el-table-column type="index" label="NO." width="60" align="center">
										<template slot-scope="scope">{{ (pageIndex2 - 1) * limit + scope.$index + 1
										}}</template>
									</el-table-column>
									<el-table-column prop="weeklyName" label="周报编号" min-width="200" align="center">
										<template slot-scope="scope">
											<el-button v-preventReClick type="text" size="small"
												@click="viewPdf(scope.row.finalFilePath, scope.row.weeklyName)">
												{{scope.row.weeklyName}}
											</el-button>
										</template>
									</el-table-column>
									<el-table-column label="日期" min-width="200" align="center">
										<template slot-scope="scope">
											{{ scope.row.beginTime }} ~~ {{ scope.row.endTime }}
										</template>
									</el-table-column>
									<el-table-column prop="insDate" label="制作日期" min-width="160" align="center">
									</el-table-column>
									<el-table-column label="操作" width="80" fixed="right" align="left">
										<template slot-scope="scope">
											<el-button v-preventReClick type="text" size="small"
												@click="downloadHandle(scope.row.recNo)">附件查看</el-button>
										</template>
									</el-table-column>
								</el-table>
							</div>
							<el-pagination class="my-pagination" @size-change="sizeChangeHandle"
								@current-change="currentChangeHandle" :current-page="page" :page-sizes="[10, 20, 50, 100]"
								:page-size="limit" :total="totalCount" layout="total, sizes, prev, pager, next, jumper">
							</el-pagination>
						</el-col>
					</el-row>
				</el-card>
			</div>
		</el-col>
		<project-weekly-report-download v-if="downloadVisible" ref="projectWeeklyReportDownload"
			@refreshDataList="getDataList"></project-weekly-report-download>
		<view-pdf v-if="viewPdfVisible" ref="viewPdf" @refreshDataList="dataList"></view-pdf>
	</div>
</template>
<script>
import $common from "@/utils/common.js"
import ProjectWeeklyReportDownload from "./project-weekly-report-download.vue"
import ViewPdf from "../projectInfo/viewPdf.vue"
export default {
	data() {
		return {
			viewPdfVisible: false,
			showSearch: false,
			showDownload: false,
			showAdd: false,
			showEdit: false,
			showDelete: false,
			showCheck: false,
			action: '',
			showArchive: false,
			showRowDownload: false,
			pageSpan: 12,
			refirmVisible: false,
			addOrUpdateVisible: false,
			fileUploadVisible: false,
			exportVisible: false,
			auditVisible: false,
			enclosureVisible: false,
			reportUploadVisible: false,
			downloadVisible: false,
			reportFileUploadVisible: false,
			form: {},
			limit: 20,
			page: 1,
			totalCount: 0,
			dataList: [],
			tableSelVal: [],
			// 显示序号
			pageIndex2: 1,
			screenHeight: 0,
		};
	},
	components: {
		ProjectWeeklyReportDownload,
		ViewPdf
	},
	mounted() {
		this.screenHeight = window.innerHeight
		this.showSearch = $common.isAuth('weekly:search');
		this.showDownload = $common.isAuth('weekly:download');
		this.showAdd = $common.isAuth('weekly:add');
		this.showEdit = $common.isAuth('weekly:edit');
		this.showDelete = $common.isAuth('weekly:delete');
		this.showCheck = $common.isAuth('weekly:check');
		this.showArchive = $common.isAuth('weekly:archive');
		this.showRowDownload = $common.isAuth('weekly:download');
		if (!this.showSearch && !this.showDownload && !this.showAdd) {
			this.pageSpan = 24;
		}
		this.getDataList();
	},
	methods: {
		enclosureHandle(id) {
			this.enclosureVisible = true
			this.$nextTick(() => {
				this.$refs.enclosureAddOrUpdate.init(id)
			})
		},
		selectFile(url) {
			window.open(url);
		},
		downloadHandle(id) {
			this.downloadVisible = true;
			this.$nextTick(() => {
				this.$refs.projectWeeklyReportDownload.init(id)
			})
		},
		viewPdf(filePath, filename) {
			// $common.viewFile(filePath)
			if(filePath == null || filePath == undefined || filePath == '') {
				this.$message.error("没有可预览的文件！");
				return;
			} 
			this.viewPdfVisible = true;
			this.$nextTick(() => {
				this.$refs.viewPdf.init(filename, filePath)
			})
		},
		getDataList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/projectweeklyreportinfo/list",
				method: 'get',
				params: this.$http.adornParams({
					limit: this.limit,
					page: this.page,
					workNo: $common.getItem("workNo"),
					refirmFlg: '1'
				})
			}).then(({ data }) => {
				if (data && data.code === 200) {
					this.dataList = data.body.records;
					this.totalCount = data.body.totalCount;
					this.pageIndex2 = this.page
				} else {
					this.dataList = []
					this.totalCount = 0
					this.pageIndex2 = 1
				}
			})
		},
		tableRowClassName({ row, rowIndex }) {
			return $common.tableRowClassName({ row, rowIndex });
		},
		// 每页数
		sizeChangeHandle(val) {
			this.limit = val
			this.page = 1
			this.getDataList()
		},
		// 当前页
		currentChangeHandle(val) {
			this.page = val
			this.getDataList()
		},
		goBack() {
			this.$router.push({ name: 'workbench' });
		}
	}
};
</script>
<style lang="scss" scoped="scoped">
.selItemText {
	font-size: 14px;
	color: #1c1c1c;
	display: inline-block;
	width: 80px;
}

.my-pagination {
	margin-right: 20px !important;
}

// 设置表头样式
::v-deep(.el-table th.el-table__cell) {
	// background-color: #d3e2f4 !important;
	font-size: 15px;
	padding: 2px 0;
}

.title_color {
	height: 60px !important;
}

.my-pagination {
	margin-left: 20px !important;
}
</style>
